<div class="keyboard">
  <div *ngFor="let line of keyboardLayout" class="line">
    <div (click)="onKey(k)" *ngFor="let k of line" [style.background-color]="isGreyed(k)" class="k">{{ k }}</div>
  </div>
</div>
